import { getAlertDisplayName } from '@/common/alertType';
import type { RunStep } from '../../runHistory/runStepUtils';

/**
 * Returns "{alert name} on {shipment reference number}" for an alert trigger's step, or the alert
 * name alone if the shipment has no reference number. Null if the step has no alert trigger report.
 */
export function getAlertTriggerRunStepSummary(step: RunStep): string | null {
  const report = step.report?.alert_trigger;
  if (report === undefined) {
    return null;
  }
  const alertName = getAlertDisplayName(report.alert_type, report.title);
  if (report.shipment_reference_number === '') {
    return alertName;
  }
  return `${alertName} on ${report.shipment_reference_number}`;
}
